import React from "react";
import { VisuallyHidden } from "@streeteasy/design-system/style-utilities/visually-hidden";
import { func, oneOf, shape, string } from "prop-types";

import { searchIcon } from "../../assets";
import LISTING_TYPES from "../../constants/listingTypes";
import cookieServiceImpl from "../../services/cookieService";
import * as S from "./styled";

export const LAST_SEARCH_COOKIE = "last_search_tab";

const MobileSearchAction = ({ className, cookieService, listingType }) => (
  <S.Link
    className={className}
    href="/"
    onClick={() => {
      cookieService.set(LAST_SEARCH_COOKIE, listingType);
    }}
  >
    <S.Icon alt="" src={searchIcon} />
    <VisuallyHidden>{listingType} home</VisuallyHidden>
  </S.Link>
);

MobileSearchAction.propTypes = {
  className: string,
  listingType: oneOf(Object.values(LISTING_TYPES)).isRequired,
  cookieService: shape({
    set: func.isRequired
  })
};

MobileSearchAction.defaultProps = {
  className: null,
  cookieService: cookieServiceImpl
};

export default MobileSearchAction;
